import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { HearingLossModel } from '../model/index';

@Injectable()
export class HearingLossService {
    private headers = new Headers({
       'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'

        //'Content-Type': 'application/x-www-form-urlencoded charset=UTF-8', 'Accept': 'q=0.8;application/json;q=0.9'
    });
    private hearinglossUrl = 'api/hearingLoss';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getHearinglossList(query: any): Promise<HearingLossModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.hearinglossUrl}/hearinglossList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getHearingloss(id: number): Promise<HearingLossModel> {
        const url = `${this.hearinglossUrl}/hearinglossList?id=id}`;
        return this.http.get(url)
            .toPromise()
            .then(response => response.json().data as HearingLossModel)
            .catch(this.handleError);
    }

    deleteHearingloss(id: any): Promise<HearingLossModel> {
        const url = `${this.hearinglossUrl}/deleteHearingloss`;
        return this.http
            .post(url, $.param({ id: id }), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as HearingLossModel)
            .catch(this.handleError);
    }

    addUpdateHearingloss(hearinglossData: any): Promise<HearingLossModel> {

        const url = `${this.hearinglossUrl}/addUpdateHearingloss`;

        return this.http
            .post(url, $.param(hearinglossData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as HearingLossModel)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/hearingLoss.service.ts